$(function () {
  if ($('.collection').length) {
    $('.collection').parent().css('width', '100%');
    $('.collection').show();
  }
  if ($('.my-page')) {
    $('#my-page-unit-button').click(function () {
      $('.my-page__span').removeClass('current');
      $(this).find('.my-page__span').addClass('current');
      $('#my-page-history').hide();
      $('#my-page-unit').fadeIn();
    });
    $('#my-page-history-button').click(function () {
      $('.my-page__span').removeClass('current');
      $(this).find('.my-page__span').addClass('current');
      $('#my-page-unit').hide();
      $('#my-page-history').fadeIn();
    });
  }
  if ($('#contact-success').length) {
    $('.contact__wrap').before($('#contact-success'));
    $('.contact__wrap').hide();
  }
  $(".contact__submit").prop('disabled', true);
  if ($('.contact__form').length) {
    $('input, select, textarea').change(function () {
      if (
        $('input[name="contact[お名前]').val() === "" ||
        $('input[name="contact[カナ]').val() === "" ||
        $('input[name="contact[郵便番号]').val() === "" ||
        $('input[name="contact[市区町村名]').val() === "" ||
        $('input[name="contact[番地・ビル名]').val() === "" ||
        $('input[name="contact[email]').val() === "" ||
        $('input[name="contact[メールアドレス(確認)]').val() === "" ||
        $('input[name="contact[電話番号]').val() === "" ||
        $('textarea[name="contact[お問い合わせ内容]').val() === "" ||
        $('select[name="contact[都道府県]').val() === ""
      ) {
        $('.mail-not-equal').hide();
        $(".contact__submit").prop('disabled', true);
        $(".contact__var--text").show();
      } else {
        if ($('input[name="contact[email]').val() !== $('input[name="contact[メールアドレス(確認)]').val()) {
          $('.mail-not-equal').show();
          $(".contact__var--text").show();
          $(".contact__submit").prop('disabled', true);
        } else {
          $('.mail-not-equal').hide();
          $(".contact__var--text").hide();
          $(".contact__submit").prop('disabled', false);
        }
      }
    });
  }
  $(".delivery__item--submit").prop('disabled', true);
  if ($('#delivery').length) {
    $('input, select, textarea').change(function () {
      if (
        $('input[name="contact[お名前]').val() === "" ||
        $('input[name="contact[お名前(フリガナ)]').val() === "" ||
        $('input[name="contact[郵便番号]').val() === "" ||
        $('input[name="contact[市区町村]').val() === "" ||
        $('input[name="contact[それ以降住所]').val() === "" ||
        $('input[name="contact[電話番号]').val() === "" ||
        $('input[name="contact[email]').val() === "" ||
        $('input[name="contact[集荷希望日]').val() === "" ||
        $('input[name="contact[お支払い方法]').val() === "" ||
        $('input[name="contact[ヤマト運輸着払い伝票]').val() === "" ||
        $('input[name="contact[集荷希望時間]').val() === "" ||
        $('input[name="contact[集荷希望時間]').val() === "" ||
        $('input[name="contact[研磨作業の前に価格などの連絡]').val() === "" ||
        $('textarea[name="contact[研磨を希望する刃物の種類と本数]').val() === "" ||
        $('select[name="contact[都道府県]').val() === ""
      ) {
        $(".delivery__item--submit").prop('disabled', true);
        $(".contact__var--text").show();
      } else {
        $(".delivery__item--submit").prop('disabled', false);
        $(".contact__var--text").hide();
      }
    });
  }
});
